if (!customElements.get('ps-product-selector')) {
  customElements.define('ps-product-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-purchase-labels]').textContent);
      this.addEventListener('change', event => {
        const input = event.target.closest('input[data-available]');
        if (!input) return;
        const form = this.querySelector('form');
        form.querySelector('input[name="id"]').value = input.value;
        this.querySelector('[data-price]').textContent = input.dataset.price;
        this.querySelector('[data-variant-name]').textContent = input.dataset.title;
        const addButton = this.querySelector('[data-add-button]');
        addButton.disabled = input.dataset.available !== 'true';
        addButton.textContent = addButton.disabled ? this.labels.sold : this.labels.add;
        this.dispatchEvent(new CustomEvent('ps:variant-change', { bubbles: true, detail: { image: input.dataset.image, title: input.dataset.title, handle: this.dataset.productHandle } }));
      });
    }
  });
}
if (!customElements.get('ps-protection-hero')) {
  customElements.define('ps-protection-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const version = event.target.closest('[data-version]');
        if (version) {
          this.querySelectorAll('[data-version]').forEach(button => button.setAttribute('aria-pressed', String(button === version)));
          this.querySelectorAll('[data-gallery-panel]').forEach(panel => panel.hidden = panel.dataset.galleryPanel !== version.dataset.version);
          this.querySelectorAll('[data-product-panel]').forEach(panel => panel.hidden = panel.dataset.productPanel !== version.dataset.version);
          this.querySelector('[data-product-title]').textContent = version.dataset.title;
        }
        const thumbnail = event.target.closest('[data-gallery-image]');
        if (thumbnail) {
          const gallery = thumbnail.closest('[data-gallery-panel]');
          gallery.querySelectorAll('[data-gallery-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
          const image = gallery.querySelector('.ps-selected-image');
          image.src = thumbnail.dataset.galleryImage;
          image.removeAttribute('srcset');
          image.alt = thumbnail.dataset.imageAlt;
        }
      });
      this.addEventListener('ps:variant-change', event => {
        const panel = [...this.querySelectorAll('[data-gallery-panel]')].find(item => item.dataset.galleryPanel === event.detail.handle);
        if (!panel || !event.detail.image) return;
        const image = panel.querySelector('.ps-selected-image');
        image.src = event.detail.image;
        image.removeAttribute('srcset');
        image.alt = event.detail.title;
      });
    }
  });
}
